export const getBuildDefaultLanguage = () => {
  const buildName = window.REACT_APP_BUILD_NAME !== 'REPLACE_REACT_APP_BUILD_NAME' 
    ? window.REACT_APP_BUILD_NAME 
    : process.env.REACT_APP_BUILD_NAME || 'tazadeal';
  return buildName === 'athena' ? 'ru' : 'en';
};